// features/Vault/hooks/useVaultBootstrap.ts
import { useEffect, useRef } from 'react'

import { type ICategory } from 'types/interfaces/ITypes'

type Args = {
  categories: ICategory[]
  idParam: any
  stateCategoryId: any
  ALL_CATEGORY: ICategory
  setActiveCategory: (v: any) => void
  setShouldFetch: (v: boolean) => void
}

export function useVaultBootstrap({
  categories,
  idParam,
  stateCategoryId,
  ALL_CATEGORY,
  setActiveCategory,
  setShouldFetch,
}: Args) {
  const bootstrapped = useRef(false)

  useEffect(() => {
    if (bootstrapped.current) return

    if (!Array.isArray(categories)) return

    if (categories.length === 0) {
      setActiveCategory((prev: any) => {
        if (prev?.[0]?.id !== ALL_CATEGORY.id) return [ALL_CATEGORY]
        return prev
      })
      setShouldFetch(true)
      bootstrapped.current = true
      return
    }

    let nextCategory: ICategory

    if (stateCategoryId !== null) {
      nextCategory =
        categories.find(cat => cat.id === String(stateCategoryId)) ??
        ALL_CATEGORY
    } else if (idParam) {
      nextCategory =
        categories.find(cat => cat.id === String(idParam)) ??
        ALL_CATEGORY
    } else {
      nextCategory = ALL_CATEGORY
    }

    setActiveCategory((prev: any) => {
      if (prev?.[0]?.id !== nextCategory.id) return [nextCategory]
      return prev
    })

    setShouldFetch(true)
    bootstrapped.current = true
  }, [categories, idParam, stateCategoryId, ALL_CATEGORY, setActiveCategory, setShouldFetch])
}